/** Create/edit form for a Timer. Validated against `createTimerSchema`. */
import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import {
  EVENT_TYPES,
  createTimerSchema,
  type CreateTimerInput,
} from "@aos/shared";

import { FormShell } from "../skills/_components/FormShell";
import {
  optionsFromEnum,
  SelectField,
  TextField,
} from "../skills/_components/form";

export interface TimerFormProps {
  action: "create" | "edit";
}

export function TimerForm({ action }: TimerFormProps) {
  const form = useForm<CreateTimerInput>({
    resolver: zodResolver(createTimerSchema),
    refineCoreProps: { resource: "timers", action },
  });

  const {
    refineCore: { onFinish, formLoading },
    handleSubmit,
  } = form;

  return (
    <FormShell
      title={action === "create" ? "New Timer" : "Edit Timer"}
      resource="timers"
      isSubmitting={formLoading}
      onSubmit={handleSubmit((values) => onFinish(values))}
    >
      <TextField
        form={form}
        name="name"
        label="Name"
        placeholder="Weekly management pack"
      />
      <TextField
        form={form}
        name="schedule"
        label="Schedule"
        placeholder="0 8 * * MON"
        description="Cron-ish 'm h dom mon dow'. * is supported."
      />
      <SelectField
        form={form}
        name="emitted_event_type"
        label="Emitted Event Type"
        options={optionsFromEnum(EVENT_TYPES)}
        description="Timers fire timer.fired; the intended type rides in the payload."
      />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <TextField
          form={form}
          name="status"
          label="Status"
          placeholder="active"
        />
        <TextField
          form={form}
          name="context_id"
          label="Context ID"
          placeholder="cx_… (optional)"
        />
      </div>
    </FormShell>
  );
}

export default TimerForm;
